/**
 * SRE Telemetry & Selenographic Coordinate HUD
 * Displays real-time rendering statistics, camera altitude,
 * dynamic LOD level, and live cursor coordinates.
 */

import { formatLat, formatLon } from '../utils/math.js';

export class TelemetryHUD {
  constructor(container) {
    this.container = container;
    this.element = document.createElement('div');
    this.element.className = 'telemetry-hud glass-panel';
    this.container.appendChild(this.element);

    this.render();
  }

  render() {
    this.element.innerHTML = `
      <div class="hud-item coordinates-box">
        <span class="hud-label">SELENOGRAPHIC COORDS</span>
        <span class="hud-value" id="hud-coords">--° -- | --° --</span>
      </div>
      <div class="hud-item">
        <span class="hud-label">ALTITUDE</span>
        <span class="hud-value" id="hud-altitude">-- km</span>
      </div>
      <div class="hud-item">
        <span class="hud-label">LOD RESOLUTION</span>
        <span class="hud-value lod-badge" id="hud-lod">ORBITAL</span>
      </div>
      <div class="hud-item sre-stats">
        <span class="hud-label">RENDER SRE</span>
        <span class="hud-value small" id="hud-fps">60 FPS | 0ms</span>
      </div>
    `;

    this.coordsEl = this.element.querySelector('#hud-coords');
    this.altEl = this.element.querySelector('#hud-altitude');
    this.lodEl = this.element.querySelector('#hud-lod');
    this.fpsEl = this.element.querySelector('#hud-fps');
  }

  update(telemetry) {
    // 1. Coordinates
    if (telemetry.hoverCoords && telemetry.hoverCoords.valid) {
      const latStr = formatLat(telemetry.hoverCoords.lat);
      const lonStr = formatLon(telemetry.hoverCoords.lon);
      this.coordsEl.textContent = `${latStr} | ${lonStr}`;
      this.coordsEl.classList.add('active');
    } else {
      this.coordsEl.textContent = 'HOVER SURFACE';
      this.coordsEl.classList.remove('active');
    }

    // 2. Altitude
    const alt = telemetry.altitudeKm;
    this.altEl.textContent = `${alt.toLocaleString()} km`;

    // 3. Dynamic LOD Level
    if (alt > 4500) {
      this.lodEl.textContent = 'LOD 0 (GLOBAL SYNOPTIC)';
      this.lodEl.className = 'hud-value lod-badge lod-0';
    } else if (alt > 1200) {
      this.lodEl.textContent = 'LOD 1 (REGIONAL BASIN)';
      this.lodEl.className = 'hud-value lod-badge lod-1';
    } else {
      this.lodEl.textContent = 'LOD 2 (SUB-ORBITAL RECON)';
      this.lodEl.className = 'hud-value lod-badge lod-2';
    }

    // 4. SRE Telemetry
    const fps = telemetry.fps || 60;
    const calls = telemetry.drawCalls || 0;
    this.fpsEl.textContent = `${fps} FPS • ${calls} Calls`;
  }
}
